import { render, staticRenderFns } from "./CustomerAssistant.vue?vue&type=template&id=66e88b22&"
import script from "./CustomerAssistant.vue?vue&type=script&lang=ts&"
export * from "./CustomerAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports